import { Space } from "antd";

const Messages = () => {
 

  return (
    <Space direction="horizontal" wrap size={[10]} style={{ margin: "10px" }}>
       <h1> Messages Page </h1>
    </Space>
  );
};

export default Messages;
